import api from "../utils/api";
const API_URL = process.env.REACT_APP_API_URL;

export async function getPaymentsForProject(projectId) {
  const response = await api.post(`${API_URL}/payments.php`, {
    action: "get",
    projectId,
  });
  return response.data.payments;
}

export async function addPayment(paymentData) {
  const response = await api.post(`${API_URL}/payments.php`, {
    ...paymentData,
    action: "add",
  });
  return response.data;
}

export async function getPaymentDetails(paymentId) {
  const response = await api.post(`${API_URL}/payments.php`, {
    action: "getPaymentDetail",
    id: paymentId,
  });
  return response.data.payment;
}

export async function updatePayment(paymentId, paymentData) {
  const response = await api.post(`${API_URL}/payments.php`, {
    ...paymentData,
    action: "update",
    id: paymentId,
  });
  return response.data;
}

export async function getOverduePayments() {
  const response = await api.post(
    `${API_URL}/payments.php`,
    {
      action: "getOverdue",
    }
  );
  console.log(response.data.payments);
  return response.data.payments;
}

export async function sendPaymentReminder(payload) {
  const response = await api.post(`${API_URL}/payments.php`, {
    ...payload,
    action: "sendReminder",
  });
  return response.data.payments;
}

export async function holdProject(projectId) {
  const response = await api.post(`${API_URL}/project.php`, {
    id: projectId,
    action: "holdProject",
  });
  return response.data;
}
